function imageExists(url, callback) 
{
  var img = new Image();
  img.onload = function() { callback(true); };
  img.onerror = function() { callback(false); };
  img.src = url;
}

// Bold Product Options - Custom Swatch Functionality

BOLD.options.app.on('options_loaded', shappify_options_rendered);
var asset_url = (' //camodernhome.com/cdn/shop/files/no-image.png?583545' ).split('no-image.png');
var assetPath;
var lastSuccess;
var install = false;                 


function shappify_options_rendered(i) {
  if(install == false) {
    install = true;

    lastSuccess = $('.gallery-cell.is-selected img').attr('data-image-src');
    /*=========================
  Swatch Setup
  ==========================*/
  $(document).ready(function(){  
      $('.bold_option_title:contains("ImageSwap-")').each(function() {
        var elementTitle = $(this).html().replace("ImageSwap-","");
        var selectTitle = $(this).siblings('.bold_option_element').children('select').children('option').first().text().replace("ImageSwap-","");
        $(this).html(elementTitle);
        $(this).siblings('.bold_option_element').children('select').addClass('image-swap').children('option').first().text(selectTitle);
        $(this).siblings('.bold_option_element').find('input[type="radio"]').addClass('image-swatch');
      });
  });

    $('input[type="radio"]').each(function() {
      var inputRadio = $(this).val().toLowerCase();
      if ( inputRadio === 'swatch-color' ) {
        $(this).parents('.bold_option_element').addClass('swatch-color');
        $(this).parents('.bold_option').addClass('selector');
        $(this).parents('.bold_option_value').remove();
      } else if ( inputRadio === 'swatch-image') {
        $(this).parents('.bold_option_element').addClass('swatch-image');
        $(this).parents('.bold_option').addClass('selector');
        $(this).parents('.bold_option_value').remove();
      }
    });

    $('.swatch-color').find('label').each(function() {
      var labelColorName = $(this).find('.bold_option_value_title').text().slice(8);
      var labelColorHex = $(this).find('.bold_option_value_title').text().substr(0,7);
      $(this).prepend('<span class="colorhex" style="background-color:'+labelColorHex+'"></span>');
      $(this).find('input[type="radio"]').css('display','none').attr('data-hex',labelColorHex);
    });

    $('.swatch-image').find('label').each(function() {
      var baseTitle = $(this).find('.bold_option_value_title').text();
      var labelBGSrc = asset_url[0] + baseTitle.toLowerCase().replace(/\s/g,"") + '.png' + asset_url[1];
      $(this).find('.bold_option_value_element').after('<img src="'+labelBGSrc+'" height="30" width="30" data-tooltip-img="'+labelBGSrc+'">');
      $(this).find('input[type="radio"]').css('display','none');
    });


    $('.bold_option_title').each(function() {
      var moo = $(this).html().split("Graphite ").join("").split("Carbon ").join("").split("Mineral ").join("").split("Polished Aluminum ").join("").split("Satin Aluminum ").join("");
      $(this).html(moo);
    });




    /*=========================
  OnClick Events
  ==========================*/

    $('.image-swap').change(function() {
      console.log('buildimage change');
      buildimage();
    });

    
    $('.swatch-color').find('input[type="radio"]').on('click', function() {
      $(this).parents('label').find('.colorhex').addClass('is-selected');
      $(this).parents('.bold_option_value').siblings().find('label').find('.colorhex').removeClass('is-selected');
      // buildimage();

      //This timeout is set to accomodate a specific style loading issue with CAModernHome
      setTimeout(function(){ buildimage(); },300);
    });

    $('.swatch-image').find('input[type="radio"]').on('click', function() {
      $(this).parents('label').find('img').addClass('is-selected');
      $(this).parents('.bold_option_value').siblings().find('label').find('img').removeClass('is-selected');
      // buildimage();

      //This timeout is set to accomodate a specific style loading issue with CAModernHome
      setTimeout(function(){ buildimage(); },300);
    });

    $('.swatch-color .bold_option_value').click(function() {
      var option_text = $('.bold_option_value_title', this).text().split('-')[1];
      $(this).parents('.bold_option').find('.option_title').remove();
      $(this).parents('.bold_option').find('.bold_option_title').after('<div class="option_title">' + option_text + '</div>');
    });


    $('.swatch-image .bold_option_value').click(function() {
      var option_text = $('.bold_option_value_title', this).text();
      $(this).parents('.bold_option').find('.option_title').remove();
      $(this).parents('.bold_option').find('.bold_option_title').after('<div class="option_title">' + option_text + '</div>');
    });
    

  }
}

function buildimage() {

  assetPath = "";

  $('.image-swap').each(function() {
    console.log($(this));
    if ( $(this).val() == "" ) {
      assetPath = assetPath + "_" + $(this).children('option:eq(1)').text().toLowerCase().replace(/\s/g,'');
    } else {
      assetPath = assetPath + "_" + $(this).val().toLowerCase().replace(/\s/g,'');
    };
  });
  console.log(assetPath);

  $('.swatch-color').each(function(index) {
    if ( $(this).find('input[type="radio"]').is(':checked') ) {
      assetPath = assetPath + "_" + $(this).find('input[type="radio"]:checked').val().slice(8).toLowerCase().replace(/\s/g,'');
    } else {
      assetPath = assetPath + "_" + $(this).find('input[type="radio"]').first().val().slice(8).toLowerCase().replace(/\s/g,'');
    };
  });
  console.log(assetPath);

  $('.swatch-image').each(function(index) {


    if ( $(this).find('input[type="radio"]').is(':checked') ) {
      assetPath = assetPath + "_" + $(this).find('input[type="radio"]:checked').val().toLowerCase().replace(/\s/g,'');
    } else {
      assetPath = assetPath + "_" + $(this).find('input[type="radio"]').first().val().toLowerCase().replace(/\s/g,'');
    };


  });
  console.log(assetPath);

  var swatchSlug = "";

  var truncateCheck = swatchSlug + assetPath;

  if(truncateCheck.length > 200) {
    var truncatedasset = truncateCheck.substr(0, 200);
    assetPath = asset_url[0] + truncatedasset + ".png" + asset_url[1];
  } else {
    assetPath = asset_url[0] + swatchSlug + assetPath + ".png" + asset_url[1];
  }


  imageExists(assetPath, function(exists) 
  {
    if(exists == false)
    {
      $('.product-active-image').attr('src',lastSuccess);
      console.log('lastSuccess', lastSuccess);
    }
    else
    {
      $('.product-active-image').attr('src',assetPath);
      console.log('assetPath', assetPath);
    }

    /*
    setTimeout(function()
    {
      $('.product-active-image.zoom').elevateZoom({
        easing : true,
        zoomWindowHeight:400, 
        zoomWindowWidth:400,
        borderSize: 0     
      });
    }, 1000);
    */
    
  });


}


BOLD.options.app.on('options_loaded', function(data){
  setTimeout(function() {
    $('.swatch-image .bold_option_value').mouseover(function(evt) {
      var selectedSwatch = $(this);
      var selectedSrc = selectedSwatch.find('img').attr('src');

      $('#swatchZoom').html('<img />');

      $('#swatchZoom img').attr('src', selectedSrc);
      $('#swatchZoom').offset({
        top: selectedSwatch.offset().top + selectedSwatch.height() + 10,
        left: selectedSwatch.offset().left
      }).css({
        'visibility' : 'visible'
      });
    });

    $('.swatch-image .bold_option_value').mouseleave(function(evt) {
      $('#swatchZoom').css({
        'visibility' : 'hidden'
      });
    });


    $('.swatch-color .bold_option_value').mouseover(function(evt) {
      var selectedSwatch = $(this);
      var selectedHex = selectedSwatch.find('.bold_option_value_element .image-swatch').data('hex');
      $('#swatchZoom').offset({
        top: selectedSwatch.offset().top + selectedSwatch.height() + 10,
        left: selectedSwatch.offset().left
      }).css({
        'visibility': 'visible',
        'background' : selectedHex
      });
    });

    $('.swatch-color .bold_option_value').mouseleave(function(evt) {
      $('#swatchZoom').css({
        'visibility': 'hidden'
      });
    });
  }, 100);
});        